<template>
    <div>
        <Row class="p-5" v-show="order.notesIncomplete">
            <Col span="6" class="text-r">驳回原因：</Col>
            <Col span="18" class="c-red">{{order.notesIncomplete}}</Col>
        </Row>
        <Group title="订单概况">
            <Cell title="订单编号：" :value="order.code"></Cell>
            <Cell title="订单创建时间：" :value="order.dateCreate"></Cell>
            <Cell title="受理时间：" :value="order.dateAccept || '--'"></Cell>
            <Cell title="交付时间：" :value="order.dateDeliver || '--'"></Cell>
            <Cell title="完成制作时间：" :value="order.dateMade || '--'"></Cell>
            <Cell title="订单状态：">
                <span v-dict:EntityGzwOrder_orderState="order.orderState"></span>
            </Cell>
            <Cell title="订单类型：">
                <span v-dict:EntityGzwOrder_orderType="order.orderType"></span>
            </Cell>
            <Cell title="取货方式：">
                <span v-dict:EntityGzwOrder_deliverType="order.deliverType"></span>
            </Cell>
            <Cell title="取章地址：" :value="order.company.regAddress || '--'" v-show="order.deliverType==='0'"></Cell>
            <Cell title="邮寄地址：" :value="order.deliverAddress || '--'" v-show="order.deliverType==='1'"></Cell>
            <Cell title="大厅取章地址："
                  :value="order.company.bizSetupJson&&order.company.bizSetupJson.deliver.centerAddress.address || '--'"
                  v-show="order.deliverType==='2'"></Cell>
            <Cell title="印章数量：" :value="order.seals&&order.seals.length || '--'"></Cell>
            <Cell title="订单总价：">{{order.totalPrice | currency}}</Cell>
            <Cell title="快递单号：" :value="order.deliverTrackingNo"
                  v-show="order.orderState == 4 && order.deliverType == 1 && order.deliverTrackingNo"></Cell>
        </Group>
        <Group title="支付信息">
            <Cell title="支付状态：">{{order.orderState< 1 ? '未支付': '已支付'}}</Cell>
            <Cell title="在线支付类型：">
                <span v-dict:DictStd_payType="order.payType"></span>
            </Cell>
            <Cell title="付款时间：" :value="order.datePaid"></Cell>
            <!-- <Cell title="支付回执：" :value="order.onlinePayBankslip"></Cell> -->
        </Group>
      <Group title="承接刻章店信息">
        <Cell title="刻章店名称：" :value="order.company.name"></Cell>
        <Cell title="统一社会信用代码：" :value="order.company.uscc"></Cell>
        <Cell title="门店地址：" :value="order.company.regAddress"></Cell>
        <Cell title="联系电话：" :value="order.company.phone"></Cell>

      </Group>

      <Group title="申请企业信息">
            <Cell title="企业名称：" :value="order.name"></Cell>
            <Cell title="统一社会信用代码：" :value="order.uscc"></Cell>
            <Cell title="营业执照：">
                <ImageView :src="order.usccOss"></ImageView>
            </Cell>
        </Group>
        <Group title="法人代表">
            <Cell title="姓名：" :value="order.crpName"></Cell>
            <Cell title="身份证号：" :value="order.crpCertNo"></Cell>
            <Cell title="手机号：" :value="order.crpPhone"></Cell>
            <Cell title="身份证正面：">
                <ImageView :src="order.crpCertFrontOss"></ImageView>
            </Cell>
            <Cell title="身份证反面：">
                <ImageView :src="order.crpCertBackOss"></ImageView>
            </Cell>
        </Group>
        <Group title="经办人">
            <Cell title="姓名：" :value="order.opName"></Cell>
            <Cell title="身份证号：" :value="order.opCertNo"></Cell>
            <Cell title="手机号：" :value="order.opPhone"></Cell>
            <Cell title="身份证正面：">
                <ImageView :src="order.opCertFrontOss"></ImageView>
            </Cell>
            <Cell title="身份证反面：">
                <ImageView :src="order.opCertBackOss"></ImageView>
            </Cell>
            <Cell title="法人委托书照片：">
                <ImageView :src="order.opPoaOss"></ImageView>
            </Cell>
        </Group>

        <Group v-show="order.orderType==='1'" title="工商推送基本信息">
            <Cell title="信用代码：" :value="order.uscc"></Cell>
            <Cell title="单位名称：" :value="order.name"></Cell>
            <Cell title="法定代表人：" :value="order.crpName"></Cell>
            <Cell title="法人证件类型：">
                <span v-dict:DictGb_personCertType="order.crpCertType"></span>
            </Cell>
            <Cell title="法人证件号码：" :value="order.crpCertNo"></Cell>
            <Cell title="法人登记手机：" :value="order.crpPhone"></Cell>
            <Cell title="经办人：" :value="order.opName"></Cell>
            <Cell title="经办人证件类型：">
                <span v-dict:DictGb_personCertType="order.opCertType"></span>
            </Cell>
            <Cell title="经办人证件号码：" :value="order.opCertNo"></Cell>
            <Cell title="经办人登记手机：" :value="order.opPhone"></Cell>
        </Group>
        <h4 class="m-t-10 p-b-10">印章信息</h4>
        <div class="p-5 p-b-15">
            <Table :columns="col" border :data="order.seals"></Table>
        </div>
        <Group title="其它信息">
            <Cell title="补充材料照片：">
                <ImageView :src="order.matOssArrayJson"></ImageView>
            </Cell>
            <Cell title="备注：" :value="order.notes || '--'"></Cell>
        </Group>

    </div>
</template>

<script>
    import Vue from 'vue'
    import {Group, Cell} from '@/components/libs'

    export default {
        name: 'OrderInfo',
        data() {
            return {
                col: [{
                    title: '印章名称',
                    key: 'name'
                },
                    {
                        title: '印章类型',
                        render: (h, w) => h('span', {
                            directives: [{
                                name: 'dict',
                                value: w.row.sealType,
                                arg: 'DictSocietySealsite_sealType'
                            }]
                        })
                    },
                    {
                        title: '印章价格',
                        render: (h, w) => h('div', Vue.filter('currency')(w.row.matPrice))
                    },
                    {
                        title: '其它信息',
                        key: 'matName'
                    },
                ]
            }
        },
        props: {
            order: {
                required: true,
                type: Object
            }
        },
        components: {Group, Cell}
    }
</script>